export const parseAllowedCookieValue = (value, fallback, allowedValues) => {
  if (value === null || value === undefined || value === '') return fallback;

  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    return allowedValues.includes(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
};
